import React from "react";
import { Quote, Star } from "lucide-react";

const VOICES = [
  { name: "Ahmed K.", city: "Doha", tag: "Trades GCC + US", text: "I stopped keeping two apps. Tadawul in the morning, US after Maghrib, and every name already carries its screening verdict." },
  { name: "Sara A.", city: "Dubai", tag: "Savings & Murabaha", text: "The Murabaha plan finally made sense to me — I can see the commodity, the markup and the settlement date, not just a rate." },
  { name: "Yasir R.", city: "Abu Dhabi", tag: "Long-term investor", text: "It flagged that a holding of mine crossed the debt threshold before I ever thought to check. That alone earned my trust." },
  { name: "Layla M.", city: "Jeddah", tag: "First-time investor", text: "Fractional buying from a few riyals meant I could start without waiting to save up for a whole share." },
  { name: "Mohammed S.", city: "Riyadh", tag: "Dividend income", text: "The dividend statement shows the withholding tax per country. My accountant asked which platform produced it." },
  { name: "Nadia H.", city: "London", tag: "Multi-currency", text: "I fund in GBP, invest in USD and never think about the conversion. The zakat calculator at year end is the part I actually love." },
];

const Voice = ({ v }) => (
  <figure className="w-[300px] sm:w-[360px] shrink-0 rounded-3xl border border-black/5 bg-white p-6 shadow-[0_20px_60px_-45px_rgba(17,28,46,0.5)]"
    data-testid={`testimonial-${v.name.split(" ")[0].toLowerCase()}`}>
    <div className="flex items-center justify-between">
      <Quote className="h-5 w-5 text-[#3E2E65]/30" />
      <div className="flex gap-0.5">
        {[0, 1, 2, 3, 4].map((i) => <Star key={i} className="h-3 w-3 fill-[#3E2E65] text-[#3E2E65]" />)}
      </div>
    </div>
    <blockquote className="mt-4 text-sm leading-relaxed text-[#1A1330]/80">"{v.text}"</blockquote>
    <figcaption className="mt-5 flex items-center gap-3">
      <div className="h-9 w-9 rounded-full navy-strip text-[color:var(--tharwy-lime)] flex items-center justify-center text-xs font-bold">
        {v.name.slice(0, 1)}
      </div>
      <div>
        <div className="text-sm font-semibold">{v.name}</div>
        <div className="text-[11px] text-[#1A1330]/50">{v.city} · {v.tag}</div>
      </div>
    </figcaption>
  </figure>
);

export const Testimonials = () => (
  <section className="py-16 sm:py-20 overflow-hidden" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="max-w-2xl">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">What clients say</h2>
        <p className="mt-3 text-[#1A1330]/65">
          From our beta programme across the Gulf and the UK — illustrative feedback, shared with permission.
        </p>
      </div>
    </div>

    <div className="mt-10 space-y-4">
      <div className="flex gap-4 marquee-row">
        {[...VOICES, ...VOICES].map((v, i) => <Voice key={`a${i}`} v={v} />)}
      </div>
      <div className="flex gap-4 marquee-row marquee-reverse">
        {[...VOICES.slice().reverse(), ...VOICES].map((v, i) => <Voice key={`b${i}`} v={v} />)}
      </div>
    </div>

    <style>{`
      .marquee-row { width: max-content; animation: tharwy-marquee 46s linear infinite; }
      .marquee-row.marquee-reverse { animation-direction: reverse; animation-duration: 58s; }
      .marquee-row:hover { animation-play-state: paused; }
      @keyframes tharwy-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
      @media (prefers-reduced-motion: reduce) { .marquee-row { animation: none; } }
    `}</style>
  </section>
);
